export default __webpack_public_path__ + "static/media/phillips_square.eaef1841.jpg";